
import React, { useState,useEffect,useRef } from "react";

// import banner from '../images/hero-section/welding.webp';
import latest_technology from '../images/hero-section/factory_worker.webp';
import manufacturing from '../images/hero-section/high_quality_man.webp';

import industry_expert from '../images/hero-section/industry_expert.webp';
import satisfaction from '../styles/images/home_img/satisfaction.png';
import reasonable from '../styles/images/home_img/reasonable_rate.png';
import timeEfficiency from '../styles/images/home_img/time_efficiency.png';
import latest_machinery from '../styles/images/home_img/latest_machinery.png';

import about_us from "../images/hero-section/about_us.webp";

import { Link } from 'react-router-dom';

import productVideoMp4 from "../styles/video/backgound_video/front_vid.mp4";
import productPoster from '../images/hero-section/welding.webp';





const Home = () => {

  // 📌 Add these state + refs at the top
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  const sentences = [
    "Delivering high-quality industrial finishing machines worldwide.",
    "We are India's leading providers of high-quality industrial finishing machines and spare parts.",
    "Our solutions have earned trust in India and international markets, including Latin & North America, Indonesia, Russia, North & South Africa, Saudi Arabia, Algeria and beyond.",
    "At AKMAKE, we don’t just deliver machines – we deliver excellence, reliability, and long-term partnerships.",
    "We continue to expand our global presence, ensuring superior performance and reliability for industries worldwide.",
    "Join hands with us to experience world-class finishing solutions tailored to your industry’s needs."
  ];

  // timing controls
  const delayPerItem = 180;        // ms delay between items (stagger)
  const animationDuration = 900;   // ms duration of each item animation


  // IntersectionObserver: trigger when 15% visible
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const opts = { root: null, rootMargin: "-80px 0px", threshold: 0.25 };
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect(); // play once
        }
      });
    }, opts);

    io.observe(el);
    return () => io.disconnect();
  }, []);

  const services = [
    {
      title: 'High-Quality Manufacturing',
      image: manufacturing,
      description: 'We specialize in producing top-grade industrial finishing machines for FIBC, PP woven sacks, and plastic woven fabric industries.'
    },
    {
      title: 'Latest Technology',
      image: latest_technology,
      description: 'Our state-of-the-art machines are designed to enhance production efficiency with the latest technology.'
    },
    {
      title: 'Industry Expertise',
      image: industry_expert,
      description: 'With over a decade of experience, we understand customer needs and deliver customized, high-performance solutions.',
     
    },
    
  ];

 
  const whyUs = [
    {
      title: 'Latest Machinery',
      image: latest_machinery,
    },
    {
      title: 'Reasonable Rates',
      image: reasonable,
    },
    {
      title: 'Time Efficiency',
      image: timeEfficiency,
    },
    {
      title: 'Customer Satisfaction',
      image: satisfaction,
    }
  ];

  return (
    <div className="pt-20 sm:pt-10 md:pt-10 lg:pt-10">
      <section id="product-video" className="w-full py-10 bg-black">
        <div className="container mx-auto px-4">

          {/* Video container (70% screen height) */}
          <div className="relative w-full mx-auto bg-blac rounded-lg overflow-hidden shadow-lg h-[70vh]">

            {/* The Video */}
            <video
              className="w-full h-full object-contain bg-black rounded-lg translate-x-[15vw]"
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
              poster={productPoster}
            >
              <source src={productVideoMp4} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* 🔥 OVERLAY CONTENT (Your Heading + Button) */}
            <div className="absolute inset-0 flex items-center px-10">
              <div className="md:w-1/2">

                <h1 className="text-white font-medium text-3xl md:text-4xl leading-tight mb-2 drop-shadow-lg">
                  AKMAKE Engineering
                </h1>

                <p className="text-white text-lg mb-8 mt-4 drop-shadow-lg font-medium">
                  Transforming Your <br/>
                  Vision into Reality with Cutting Edge Automation
                </p>

                <Link
                  to="/contact-us"
                  className="px-6 py-3 bg-[#c8a876] text-white rounded-full hover:bg-[#c09858] transition duration-200 shadow-lg"
                >
                  Contact Us
                </Link>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Services Section */}
      <section className="py-20" id="services">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-10 text-center">Our Products</h2>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">

            {services.map((item, index) => (
              <div key={index} className="relative group bg-white rounded-lg shadow-md overflow-hidden">
                
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover rounded-t-lg"
                />

                <div className="bg-white text-center p-4">
                  <h3 className="text-lg font-semibold text-gray-800">{item.title}</h3>
                </div>

                <div className="absolute inset-0 bg-white bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center px-4">
                  <div className="text-black text-center">
                    <p className="text-sm md:text-base">{item.description}</p>
                  </div>
                </div>

              </div>
            ))}

          </div>
        </div>
      </section>

      {/* <section id="product-video" className="w-full py-10 bg-white">
        <div className="container mx-auto px-4"> */}

          {/* 70% of screen height — never cropped */}
          {/* <div className="w-full mx-auto rounded-lg overflow-hidden shadow-lg h-[70vh]">

            <video
              className="w-full h-full object-contain bg-black rounded-lg"
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
              poster={productPoster}
            >
              <source src={productVideoMp4} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

          </div>

        </div>
      </section> */}

      {/* About Us Section */}
      <section className="bg-gray-100" id="aboutus" ref={sectionRef}>
      <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8 px-4 md:px-12">
          {/* Text column */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-6 md:mb-8 text-left md:text-center">
              About Us
            </h2>

            <div className="space-y-2">
              {sentences.map((s, i) => {
                const delay = `${i * delayPerItem}ms`;
                return (
                  <p
                    key={i}
                    className={`text-gray-900 text-base sm:text-lg leading-relaxed text-justfy transform transition-all`}
                    style={{
                      transitionDelay: visible ? delay : "1ms",
                      transitionDuration: `${animationDuration}ms`,
                      // start state when not visible
                      opacity: visible ? 1 : 0,
                      transform: visible ? "translateY(0px)" : "translateY(14px)"
                    }}
                  >
                    {s}
                  </p>
                );
              })}
            </div>
          </div>

          {/* Image column */}
          <div className={`w-full h-full transform transition-all duration-700 ease-out ${visible ? "opacity-100 translate-x-0 scale-100" : "opacity-0 translate-x-8 scale-95"}`}>
            <img
              alt="About Us"
              className="w-full h-full object-cover rounded-lg shadow-md"
              src={about_us}
            />
          </div>
        </div>
      </div>
    </section>


      {/* Why Us Section */}
      <section className="text-gray-700 body-font mt-10">
        <div className="flex justify-center text-2xl font-bold text-gray-800 text-center">
          Why Us?
        </div>

        <div className="container px-5 py-12 mx-auto">
          <div className="flex flex-wrap text-center justify-center">

            {whyUs.map((item, idx) => (
              <div key={idx} className="p-4 md:w-1/4 sm:w-1/2">
                <div className="px-4 py-6 transform transition duration-500 hover:scale-110">
                  
                  <div className="flex justify-center">
                    <img 
                      className="w-28 mb-3" 
                      src={item.image} 
                      alt={item.title} 
                    />
                  </div>

                  <h2 className="title-font font-regular text-xl text-gray-900">
                    {item.title}
                  </h2>

                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

    </div>
  ); 
}
export default Home;